import React from "react"
import PropTypes from "prop-types"
import { createStructuredSelector } from "reselect"
// Redux
import { connect } from "react-redux"
import { getPlaceholders, parsePlaceholdersForSearchableDropdownButton } from "shared/outbox/selectors"
// components
import { SearchableDropdownButton } from "quorumdesign"
import { simpleLineBreak } from "shared/imports/sharedHelperFunctions"

/*
 * Root component for the summernote placeholder selector plugin.
 */
const placeholderProps = {
    summernoteName: PropTypes.string,
    summernoteElt: PropTypes.any,
    placeholders: PropTypes.array.isRequired,
}
const defaultProps = {
    summernoteName: "",
    summernoteElt: null,
}

export default class PlaceholderGroup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            placeholders: this.props.placeholders,
        }
        this.addPlaceholder = this.addPlaceholder.bind(this)
    }

    /**
     * Hacky method to allow the summernote to update the placeholders
     *
     * @param {Array} placeholders array of placeholder objects
     */
    updatePlaceholders = (placeholders) => {
        this.setState({ placeholders })
    }

    /*
     * toggleDropdown changes the state of the PlaceholderDropdown between
     * visible and hidden
     */
    toggleDropdown = () => {
        // this is here to avoid inserting placeholder text into the beginning of the
        // editor everytime
        // from https://maxrohde.com/2014/03/28/insert-text-at-caret-position-in-summernote-editor-for-bootstrap/
        if (!this.state.open && (this.props.summernoteElt || this.props.summernoteName)) {
            $(this.props.summernoteElt || `.${this.props.summernoteName}`).summernote("editor.saveRange")
        }
        this.setState({ open: !this.state.open })
    }

    handleClickOutside = (e) => {
        if (e.target && e.target.classList.contains("search-dropdown-input")) {
            return
        }
        if (this.state.open) {
            this.toggleDropdown()
        }
    }

    /*
     * addPlaceholder inserts the selected placeholder into the summernote email
     * editor.
     */
    addPlaceholder(placeholder) {
        // this is here to avoid inserting placeholder text into the beginning of the
        // editor everytime
        // from https://maxrohde.com/2014/03/28/insert-text-at-caret-position-in-summernote-editor-for-bootstrap/
        $(this.props.summernoteElt || `.${this.props.summernoteName}`).summernote("editor.restoreRange")

        $(this.props.summernoteElt || `.${this.props.summernoteName}`).summernote("editor.focus")

        // also use simpleLineBreak instead of lineBreaks here because summernote
        // will add extra formatting otherwise
        $(this.props.summernoteElt || `.${this.props.summernoteName}`).summernote(
            "pasteHTML",
            simpleLineBreak(placeholder.value),
        )

        // close dropdown
        this.toggleDropdown()
    }

    render() {
        return (
            <SearchableDropdownButton
                dataCy="outbox-insert-placeholder-button"
                icon="puzzle-piece"
                iconFamily="fas"
                onClick={this.addPlaceholder}
                options={parsePlaceholdersForSearchableDropdownButton(this.state.placeholders)}
                placeholder="Search Placeholders..."
                text="Insert Placeholders"
            />
        )
    }
}
PlaceholderGroup.propTypes = placeholderProps
PlaceholderGroup.defaultProps = defaultProps

// for Outbox
const mapBulkEmailStateToProps = createStructuredSelector({
    placeholders: getPlaceholders,
})

export const BulkEmailPlaceholders = connect(mapBulkEmailStateToProps)(PlaceholderGroup)
